
import { Component, OnInit, Inject, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm, FormControl } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model'; 
import { Observable } from 'rxjs/Observable';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Role } from '../../security/role/role.model';
import { ENTER } from '@angular/cdk/keycodes';
import { isNgTemplate } from '@angular/compiler';

@Component({
  selector: 'app-categoria-producto-add',
  templateUrl: './categoria-producto-add.component.html',
  styleUrls: ['./categoria-producto-add.component.scss']
})
export class CategoriaProductoAddComponent implements OnInit {

  sugerencias: Observable<Sugerencia[]>;
  _selectedSugerencias: Sugerencia[] = [];
  separatorKeysCodes: number[] = [ENTER];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;
  item: CategoriaProducto;

  messageTitle: string;


  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {

    this.getSugerencias();
    
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.description = this.item.id ? this.item.description : '';
    //  this.banner.description = this.banner.id ? this.banner.description : '';
      if (!this.item.sugerencias/* && !this.banner.sugerencias*/) {
        this.item.sugerencias = [];
    //    this.banner.sugerencias = [];
      }

    });

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
    
  }

  async getSugerencias() {
    this.sugerencias = this.backendService.get(Sugerencia, Sugerencia.path, {});
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  back() {
    this.navigationService.back();
  }

  remove(sugerencia: Sugerencia): void {

    const index = this.item.sugerencias.indexOf(sugerencia);
    //const bannerIndex = this.banner.sugerencias.indexOf(sugerencia);
    if (index >= 0) {
      this.item.sugerencias.splice(index, 1);
      //this.banner.sugerencias.splice(index, 2);
    }
    this.filter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    const index = this.item.sugerencias.indexOf(event.option.value);
    //const bannerIndex = this.banner.sugerencias.indexOf(event.option.value);

    if (index >= 0) {
      return;
    }
    this.item.sugerencias.push(event.option.value);
    //this.banner.sugerencias.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.filter();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  public sugerenciaSelected(sug: Sugerencia): boolean {
    for (const sugCate of this.item.sugerencias) {
      if (sug.id === sugCate.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.sugerencias
    .map(r => r.filter(p => this._selectedSugerencias.indexOf(p) === 0));
  }
  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar los cambios en la categoría ' + this.item.description/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  /*addFile(event: any) {
    this.item.imagen = event.target.files[0];
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.item.imagen = (reader.result as string).split(',')[1];
      };
    }
  }*/

  addBanner(event: any) {
    this.item.banner = event.target.files[0];
    const bannerReader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      bannerReader.readAsDataURL(file);
      bannerReader.onload = () => {
        this.item.banner = (bannerReader.result as string).split(',')[1];
      };
    }
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
       // Update
        try {        
          await this.backendService.create(CategoriaProducto.path + "new", this.item);
          this.snackService.success('Categoria creada');
          this.router.navigate(['/categorias']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      
    }

  }



}




// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto-add/categoria-producto-add.component.ts